import React, { useState } from 'react';
import './TextBox.css';
import {
    getNumberInputClassName,
    getTelInputClassName,
    getTextInputClassName,
    shouldShowTextBoxLabel,
} from './TextBox.helpers';

const TextInput = ({ props, handleShowPassword }) => (
    <div className='position-relative'>
        <input
            type={props.type}
            className={getTextInputClassName(props)}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
            onKeyUp={props.onKeyUp}
            onKeyDown={props.onKeyDown}
            disabled={props.disabled}
            maxLength={props.maxlength}
            onBlur={props.onBlur}
            readOnly={props.readOnly}
            onPaste={props.onPaste}
        />
        {props.error && (
            <i
                className='bi bi-exclamation-circle-fill cursor info-icon-text text-error-700'
                onClick={handleShowPassword}></i>
        )}
    </div>
);

const PasswordInput = ({ props, showPassword, handleShowPassword }) => (
    <div className='position-relative'>
        <input
            type={showPassword ? 'text' : props.type}
            className={`form-control custom-text-box ${props.error ? 'border-error-700' : ''}`}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
            onKeyUp={props.onKeyUp}
            onKeyDown={props.onKeyDown}
        />
        {props.error && (
            <i
                className='bi bi-exclamation-circle-fill cursor info1-icon-text text-error-700'
                onClick={handleShowPassword}></i>
        )}
        <i className='bi bi-eye-slash eye-icon cursor' onClick={handleShowPassword}></i>
    </div>
);

const NumberInput = ({ props }) => (
    <div className='position-relative'>
        <input
            type={props.type}
            className={getNumberInputClassName(props)}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
            disabled={props.disabled}
            name={props.name}
            onBlur={props.onBlur}
            readOnly={props.readOnly}
            onKeyUp={props.onKeyUp}
        />
    </div>
);

const TelInput = ({ props }) => (
    <div className='position-relative'>
        <input
            type={props.type}
            className={getTelInputClassName(props)}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
        />
    </div>
);

const SearchInput = ({ props, handleShowPassword }) => (
    <div className='position-relative'>
        <input
            type='text'
            className={`form-control search-box ${props.error ? 'border-error-700' : ''}`}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
        />
        <span className='sf-search cursor search-icon'></span>
        {props.error && (
            <i
                className='bi bi-exclamation-circle-fill cursor info-icon text-error-700'
                onClick={handleShowPassword}></i>
        )}
    </div>
);

const TextareaInput = ({ props }) => (
    <div className='position-relative'>
        <span className='float-end position-absolute top-n20 end-0 font-b3 '>
            {props.maxlength === 'auto' ? '' : `${props.textLength}/255`}
        </span>
        <textarea
            className={`form-control form-control-sm ${props.error ? 'border-error-700' : ''}`}
            id='exampleFormControlTextarea1'
            rows='3'
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
            name={props.name}
            disabled={props.disabled}
            maxLength={props.maxlength === 'auto' ? '1000' : '255'}></textarea>
    </div>
);

const InlineTextInput = ({ props }) => (
    <div className='position-relative'>
        <input
            type={props.type}
            className={`form-control custom-text-box inline-textbox ${props.error ? 'border-error-700' : ''}`}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
            onKeyUp={props.onKeyUp}
            onKeyDown={props.onKeyDown}
            id={props.id}
        />
    </div>
);

const INPUT_BY_TYPE = {
    text: TextInput,
    password: PasswordInput,
    number: NumberInput,
    tel: TelInput,
    search: SearchInput,
    textarea: TextareaInput,
    inlineText: InlineTextInput,
};

const TextBox = (props) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const InputComponent = INPUT_BY_TYPE[props.type];
    return (
        <div className=''>
            {shouldShowTextBoxLabel(props) && (
                <label className='form-label text-neutral-850 font-b3 mb-1'>
                    {props.label}
                    {props.isRequiredNeeded ? <span className='ms-n1'> *</span> : ''}
                </label>
            )}

            {InputComponent ? (
                <InputComponent props={props} showPassword={showPassword} handleShowPassword={handleShowPassword} />
            ) : null}
            {props.error && <p className='text-error-700 font-b3 font-regular mt-2'>{props.errorMessage}</p>}
            {props.capsError && (
                <div className='text-error-700 font-b3 font-regular mt-2'>{props.capsErrorMessage}</div>
            )}
        </div>
    );
};

export default TextBox;
